export default function HudChip({
  label,
  value,
  prefix,
  suffix,
  valueClassName = "text-white",
  testId,
}) {
  return (
    <div className="cb-hud-chip px-5 py-3 min-w-[180px] flex flex-col gap-1" data-testid={testId ? `${testId}-chip` : undefined}>
      <span className="font-mono-tac text-[10px] uppercase tracking-[0.28em] text-slate-400 font-bold">
        {label}
      </span>
      <span
        className={`font-display text-2xl lg:text-3xl font-bold tracking-tighter tabular-nums ${valueClassName}`}
        data-testid={testId}
      >
        {prefix}
        {value}
        {suffix}
      </span>
    </div>
  );
}
